import { UseQueryOptions } from '@ts-rest/react-query/v5';
import { PRODUCT_QUERY_KEY } from './products.query-keys';
import { type ClientArgs, type ClientInferResponseBody } from '@ts-rest/core';
import { wasticApiContract } from '@packages/contracts';

export type ProductRoute = typeof wasticApiContract.web.products;
export type GetProductBySlugRoute = ProductRoute['getBySlug'];
export type ListProductsRoute = ProductRoute['list'];
export type ListProductFiltersRoute = ProductRoute['listFilters'];
export type ListProductSuggestionsRoute = ProductRoute['listProductSuggestions'];

export type GetProductBySlugResponse = ClientInferResponseBody<GetProductBySlugRoute, 200>['data']['product'];
export type GetProductBySlugQueryOptions = UseQueryOptions<
	GetProductBySlugRoute,
	ClientArgs,
	GetProductBySlugResponse
>;
export function createGetProductBySlugQueryOptions(productSlug: string): GetProductBySlugQueryOptions {
	return {
		queryKey:  PRODUCT_QUERY_KEY.GET_BY_SLUG(productSlug),
		queryData: { params: { productSlug } },
		select:    data => data.body.data.product,
		enabled:   !!productSlug,
	};
}

export type ListProductsResponse = ClientInferResponseBody<ListProductsRoute, 200>['data'];
export type ListProductsQueryOptions = UseQueryOptions<
	ListProductsRoute,
	ClientArgs,
	ListProductsResponse
>;
export function createListProductsQueryOptions(queryParams: Record<string, unknown>): ListProductsQueryOptions {
	return {
		queryKey:  PRODUCT_QUERY_KEY.LIST(queryParams),
		queryData: { query: queryParams },
		select:    data => data.body.data,
	};
}

export type ListProductFiltersResponse = ClientInferResponseBody<ListProductFiltersRoute, 200>['data']['filters'];
export type ListProductFiltersQueryOptions = UseQueryOptions<
	ListProductFiltersRoute,
	ClientArgs,
	ListProductFiltersResponse
>;
export function createListProductFiltersQueryOptions(): ListProductFiltersQueryOptions {
	return {
		queryKey: PRODUCT_QUERY_KEY.FILTERS(),
		select:   data => data.body.data.filters,
	};
}

export type ListProductSuggestionsResponse = ClientInferResponseBody<ListProductSuggestionsRoute, 200>['data']['suggestions'];
export type ListProductSuggestionQueryOptions = UseQueryOptions<
	ListProductSuggestionsRoute,
	ClientArgs,
	ListProductSuggestionsResponse
>;
export function createListProductSuggestionsQueryOptions(search: string): ListProductSuggestionQueryOptions {
	return {
		queryKey:  PRODUCT_QUERY_KEY.SUGGESTION(search),
		queryData: { query: { search } },
		select:    data => data.body.data.suggestions,
		enabled:   !!search,
	};
}